export default {
  functionKey: "ESTTEXTE",
  title: "ESTTEXTE",
  group: "Organisation",
  origin: [],
  target: [],
  description: "Retourne true si la valeur est du texte.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = typeof ${origin} === 'string';`;
    return { displayCode: code, safeCode: code };
  }
}
